import { action } from "@ember/object"
import { inject as service } from "@ember/service"
import Component from "@glimmer/component"
import { tracked } from "@glimmer/tracking"
import type { Planbook } from "@shared/models/planbook"
import { PLANBOOK_ROLES } from "@shared/models/planbook"
import type EmberStore from "cc-frontend/services/ember-store"
import type Rpc from "cc-frontend/services/rpc"
import parseEmails from "cc-frontend/utils/parse-emails"
import { find, forEach } from "lodash-es"

interface Args {
  planbook: Planbook
}

export default class AddIndividuals extends Component<Args> {
  @service("ember-store") store!: EmberStore
  @service session
  @service rpc!: Rpc
  @service notifier

  @tracked showShareIndividualForm = false
  @tracked email = null
  availableRoles = PLANBOOK_ROLES
  @tracked selectedRole = find(PLANBOOK_ROLES, { id: "EDITOR" })

  @action onShowShareIndividualForm() {
    this.showShareIndividualForm = true
  }

  @action hideShareIndividualForm() {
    this.showShareIndividualForm = false
  }

  @action changeRole(role) {
    this.selectedRole = role
  }

  @action addIndividualCollaborator(event) {
    let planbookId = this.args.planbook.id
    let emails = this.email || ""
    let role = this.selectedRole?.id || "VIEWER"

    forEach(parseEmails(emails), (email) => {
      this.rpc
        .planbook_collaboration_add_individual({
          role: role,
          planbookId: planbookId,
          email: email,
        })
        .then((res) => {
          if (res.responseOk === true) {
            if (res.result.ok === false && res.result.name === "ALREADY_INVITED") {
              this.notifier.success("", {
                title: `${email} has already been invited!`,
                message: "They should already have the email in their inbox.",
                duration: 3000,
                type: "is-warning",
              })
            } else if (res.result.ok === false && res.result.name === "NO_SPACE") {
              this.notifier.success("", {
                title: `${email} is at their collaboration limit. Sorry!`,
                message:
                  "They need to sign up for Cc-Pro to collaborate with more than 3 planbooks.",
                duration: 10000,
                type: "is-error",
              })
            } else if (res.result.ok === false && res.result.name === "OWNER_CANNOT_INVITE_SELF") {
              this.notifier.success("", {
                title: `You cannot invite yourself to your own planbook`,
                message:
                  "Since you own the planbook, you cannot invite yourself to it. You already have full access.",
                duration: 10000,
                type: "is-error",
              })
            } else if (res.result.ok === true) {
              this.notifier.success("", {
                title: `${email} is invited!`,
                message: "We're sending them an email now!",
                duration: 3000,
                type: "is-success",
              })
            }
          }
        })
    })

    this.email = null
    this.selectedRole = find(this.availableRoles, { id: "VIEWER" })
    this.showShareIndividualForm = false

    event.preventDefault()
  }

  @action updateEmail(event) {
    this.email = event.target.value
  }
}
